import { PermissionNodeInput } from '@control-tower/features/collaborators/models/permission-node.input';
import { PermissionNode } from '@shared/components/permissions-tree/models/permission-node.model';

export class LoadPermissionNodesFromTemplate {
  static readonly type = '[PermissionsTree] Load Permission Nodes From Template';
  constructor(
    public serviceTypes: string[],
    public controlTowerId: string
  ) {}
}

export class LoadPermissionNodesFromCollaborator {
  static readonly type = '[PermissionsTree] Load Permission Nodes From Collaborator';
  constructor(
    public collaboratorId: string,
    public controlTowerId: string
  ) {}
}

export class LoadPermissionNodesFromTemplateSuccess {
  static readonly type = '[PermissionsTree] Load Permission Nodes From Template Success';
  constructor(public nodes: PermissionNode[]) {}
}

export class LoadPermissionNodesFromTemplateFailure {
  static readonly type = '[PermissionsTree] Load Permission Nodes From Template Failure';
  constructor(public error: string) {}
}

export class UpdatePermissionNodes {
  static readonly type = '[PermissionsTree] Update Permission Nodes';
  constructor(public nodes: PermissionNode[]) {}
}

export class SetCurrentTemplateId {
  static readonly type = '[PermissionsTree] Set Current Template Id';
  constructor(public templateId: string | null) {}
}

export class SaveCollaboratorPermissionTree {
  static readonly type = '[PermissionsTree] Save Collaborator Permission Tree';
  constructor(
    public collaboratorId: string,
    public newTree: PermissionNodeInput[]
  ) {}
}

export class SaveCollaboratorPermissionTreeSuccess {
  static readonly type = '[PermissionsTree] Save Collaborator Permission Tree Success';
  constructor(public rootNodeIds: string[]) {}
}

export class SaveCollaboratorPermissionTreeFailure {
  static readonly type = '[PermissionsTree] Save Collaborator Permission Tree Failure';
  constructor(public error: string) {}
}

export class LoadPermissionNodesFromUserPreset {
  static readonly type = '[PermissionsTree] Load Permission Nodes From User Preset';
  constructor(
    public inviteeIdentifier: string,
    public controlTowerId: string
  ) {}
}

export class SaveUserPermissionPreset {
  static readonly type = '[PermissionsTree] Save User Permission Preset';
  constructor(
    public inviteeIdentifier: string,
    public inviteeType: string,
    public permissionNodes: PermissionNodeInput[]
  ) {}
}

export class SetSaveAsDefault {
  static readonly type = '[PermissionsTree] Set Save As Default';
  constructor(public value: boolean) {}
}

export class SetHasUserPreset {
  static readonly type = '[PermissionsTree] Set Has User Preset';
  constructor(public value: boolean) {}
}
